import * as React from 'react'
import * as css from './BulletsDark.module.css'
import HTag from 'components/common/HTag'
import SanityBlock from 'components/common/SanityBlock'

const BulletsDark = ({ heading, _rawContent }) => {
  return (
    <section className="bg-gradient-to-br from-suede-black to-suede-black-dark text-white">
      <div className="max-w-screen-xl mx-auto py-16 px-4 grid md:grid-cols-2 gap-x-4 gap-y-12">
        <header className="max-w-[450px] mx-auto">
          <HTag {...heading} className="h1" />
        </header>

        <div className={css.content}>
          <SanityBlock body={_rawContent} />
        </div>
      </div>
    </section>
  )
}

export default BulletsDark
